import HTTP from "@/_helpers/http";
import { CLOSEDTRADES__API } from "@/_helpers/urls";
import { CLOSEDTRADES__MUTATIONS } from "../mutation-types";
import { CLOSEDTRADES__ACTIONS } from "../action-types";

const state = {
  trades: [],
  chartData: [],
  dashboardClosedTradesData: {
    total: 0,
    totalProfit: 0,
    totalVolume: 0
  },
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  },
  summaries: {
    totalProfit: 0,
    totalVolume: 0,
    totalEquity: 0
  },
  isLoading: false,
};

const getters = {};

const mutations = {
  [CLOSEDTRADES__MUTATIONS.DASHBOARDCLOSEDTRADES](state, data) {
    state.dashboardClosedTradesData = data?.data
  },

  [CLOSEDTRADES__MUTATIONS.CLOSEDTRADESCHARTDATA](state, data) {
    state.chartData = data?.data
  },

  [CLOSEDTRADES__MUTATIONS.CLOSEDTRADES](state, data) {

    // Update trades
    state.trades = data?.data?.trades || [];

    // Update pagination
    state.pagination = data?.data?.pagination || {
      total: 0,
      perPage: 10,
      currentPage: 1,
      lastPage: 1
    };

    // Update summaries
    state.summaries = data?.data?.summaries || {
      totalProfit: 0,
      totalVolume: 0,
      totalEquity: 0
    };

    state.lastUpdate = new Date().toISOString();
  },

  SET_LOADING(state, loading) {
    state.isLoading = loading;
  },
};

const actions = {
  async [CLOSEDTRADES__ACTIONS.DASHBOARDCLOSEDTRADES]({ commit, state }) {
    try {
      const response = await HTTP().get(CLOSEDTRADES__API.DASHBOARDCLOSEDTRADES);

      commit(CLOSEDTRADES__MUTATIONS.DASHBOARDCLOSEDTRADES, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CLOSEDTRADES__ACTIONS.CLOSEDTRADESCHARTDATA]({ commit, state }) {
    try {
      const response = await HTTP().get(CLOSEDTRADES__API.CLOSEDTRADESCHARTDATA);
  
      commit(CLOSEDTRADES__MUTATIONS.CLOSEDTRADESCHARTDATA, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [CLOSEDTRADES__ACTIONS.CLOSEDTRADES]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);

      const {
        page = 1,
        limit = 10,
        trading_account_type_id,
        search = "",
        duration
      } = parameter || {};

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(trading_account_type_id && { trading_account_type_id }),
        ...(duration && { duration }),
        ...(search && { search })
      }).toString();


      const response = await HTTP().get(
        `${CLOSEDTRADES__API.CLOSEDTRADES}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(CLOSEDTRADES__MUTATIONS.CLOSEDTRADES, response.data);

      commit("SET_LOADING", false);
    } catch (error) {
      console.error('Error fetching live trades:', error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions
};